// extracted by mini-css-extract-plugin
export default {"gratuity-header":"GratuityReport_gratuity-header__O2Zyn","divider":"GratuityReport_divider__qXy2q"};